$ ->
  $('[data-delete-object]').on 'click', (e) ->
    e.preventDefault();

    self = $(@);
    object = self.attr('data-delete-object')
    url = self.attr('href')
    id = self.attr('data-id')
    wrapper = self.closest("tr[data-#{object}-id='#{id}']")
    action = self.attr "data-action"
    if not action
      action = 'delete'
    name = wrapper.attr("data-#{object}-name")
    title_key = "admin.#{object}.#{action}.confirm"
    title = """
      #{__(title_key)}<br>##{escapeHtml(id)} <strong>#{escapeHtml(name)}</strong>
    """

    if object == 'segment_definitions' && action != 'restore'
      archive_segments(id, url, wrapper, title)
      return

    if (object == 'domains_lists' || object == 'tag_id_list' || object == 'publisher_id_list') && action != 'restore'
      archive_domains_tag_id_lists(id, url, wrapper, title, object)
      return

    if object == 'ips_lists' && action != 'restore'
      archive_ips_lists(id, url, wrapper, title)
      return

    confirmed_ajax {
      title: title
      url: url
      wrapper: wrapper
    }

  show_notify = (resp) ->
    if resp.notify? and resp.notify.type? and resp.notify.message?
      if resp.notify.placement? && resp.notify.placement is 'top'
        INTENT.utils.Notify.top_message resp.notify.message, resp.notify.type
      else
        INTENT.utils.Notify.message resp.notify.message, resp.notify.type

  confirmed_ajax = (params) ->
    show_confirm "#{params.title}", ->
      $.ajax({
        url: params.url
        method: 'post'
        data: {
          'id': params.id
          'confirmation': 'Y'
        },
        beforeSend: () ->
          params.wrapper.addClass 'disabled'
          Loader.show();
        error: (xhr) ->
          Loader.hide()
          try
            resp = JSON.parse xhr.responseText
            # @see application/classes/Controller/Campaigns/Advertiser.php:1427
            if resp.payload? and resp.payload.modal?
              modal =
                title: resp.payload.modal.title
                body: resp.payload.modal.body

              INTENT.utils.Modal.show modal
            else
              show_notify(resp)
          catch

          params.wrapper.removeClass 'disabled'

        success: (resp) ->
          Loader.hide()
          params.wrapper.hide()
          show_notify(resp)
      })

  archive_segments = (id, url, wrapper, title) ->
    $.ajax({
      url: "/ajax/check_campaigns_w_segment?segmentId=#{id}"
      method: 'get'
      beforeSend: () ->
        wrapper.addClass 'disabled'
        Loader.show()
      success: (resp) ->
        Loader.hide()
        wrapper.removeClass 'disabled'
        if _.isArray(resp) && resp.length
          campaigns = ""
          for campaign in resp
            campaigns += "<a href=\"/campaigns/redirect/campaigns/edit/#{campaign.id}\" target=\"_blank\">#{campaign.id}</a>, "
          campaigns = campaigns.substr(0, campaigns.length - 2)
          title += """
            <br/><br/>#{__('admin.segment_definitions.delete.confirm.prefix')}:
            <br/><div id="popup_msg_list">#{campaigns}</div>
            #{__('admin.segment_definitions.delete.confirm.postfix')}
          """

        confirmed_ajax {
          title: title
          url: url
          wrapper: wrapper
        }
      error: (xhr) ->
        Loader.hide()
        wrapper.removeClass 'disabled'
        resp = JSON.parse xhr.responseText
        show_notify(resp)
    })

  archive_ips_lists = (id, url, wrapper, title) ->
    $.ajax({
      url: "/ajax/check_campaigns_w_ip_list?ipListId=#{id}"
      method: 'get'
      beforeSend: () ->
        wrapper.addClass 'disabled'
        Loader.show()
      success: (resp) ->
        Loader.hide()
        wrapper.removeClass 'disabled'
        if _.isArray(resp) && resp.length
          campaigns = ""
          for campaign in resp
            campaigns += "<a href=\"/campaigns/redirect/campaigns/edit/#{campaign.id}\" target=\"_blank\">#{campaign.id}</a>, "
          campaigns = campaigns.substr(0, campaigns.length - 2)

          modal =
            title: __('admin.ips_lists.delete.confirm.prefix')
            body: campaigns

          INTENT.utils.Modal.show modal
        else
          confirmed_ajax {
            title: title
            url: url
            wrapper: wrapper
          }
      error: (xhr) ->
        Loader.hide()
        wrapper.removeClass 'disabled'
        resp = JSON.parse xhr.responseText
        show_notify(resp)
    })

  archive_domains_tag_id_lists = (id, url, wrapper, title, object) ->
    ajaxUrl = ''
    if object == 'domains_lists'
      ajaxUrl = "/ajax/check_campaigns_w_domain_list?domainListId=#{id}"
    if object == 'tag_id_list'
      ajaxUrl = "/ajax/check_campaigns_w_tag_id_list?tagIdListId=#{id}"
    if object == 'publisher_id_list'
      ajaxUrl = "/ajax/check_campaigns_w_publisher_id_list?publisherIdListId=#{id}"
    $.ajax({
      url: ajaxUrl
      method: 'get'
      beforeSend: () ->
        wrapper.addClass 'disabled'
        Loader.show()
      success: (resp) ->
        Loader.hide()
        wrapper.removeClass 'disabled'
        if _.isArray(resp) && resp.length
          campaigns = ""
          for campaign in resp
            if object == 'domains_lists' || ((object == 'tag_id_list' || object == 'publisher_id_list') && campaign.available)
              campaigns += "<a href=\"/campaigns/redirect/campaigns/edit/#{campaign.id}\" target=\"_blank\">#{campaign.id}</a>, "
            else
              campaigns += "#{campaign.id}, "
          campaigns = campaigns.substr(0, campaigns.length - 2)

          modal =
            title: __('admin.'+object+'.delete.confirm.prefix')
            body: campaigns

          INTENT.utils.Modal.show modal
        else
          confirmed_ajax {
            title: title
            url: url
            wrapper: wrapper
          }
      error: (xhr) ->
        Loader.hide()
        wrapper.removeClass 'disabled'
        resp = JSON.parse xhr.responseText
        show_notify(resp)
    })
